module.exports = __webpack_public_path__ + "img/no-preview-available.95368faf.jpg";